import * as React from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { Container, Row, Spacer, Text, useTheme } from '@nextui-org/react';

interface AppUnauthorizedProps {}

/**
 * @name AppUnauthorized
 * @description tbd...
 */
export function AppUnauthorized(_props: AppUnauthorizedProps) {
  const { theme } = useTheme();

  return (
    <Container>
      <Spacer />
      <Row justify="center" align="center">
        <LockClosedIcon
          style={{
            color: theme?.colors.white.value,
            height: '64px',
            width: '64px',
          }}
        />
      </Row>
      <Spacer />
      <Row justify="center" align="center">
        <Text>You are not authorized to view this content</Text>
      </Row>
    </Container>
  );
}
